/**
 * Formats an amount in Indian system with K, L, Cr abbreviations
 * @param {number|string} amount - The amount to format
 * @returns {string} - Formatted string (e.g., 20K, 2.5L, 1.2Cr)
 */
export const formatIndianAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '0';

    const num = Number(amount);
    if (isNaN(num)) return '0';

    if (num >= 10000000) {
        const abbreviated = num / 10000000;
        return abbreviated.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' Cr';
    }

    if (num >= 100000) {
        const abbreviated = num / 100000;
        return abbreviated.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' L';
    }

    if (num >= 1000) {
        const abbreviated = num / 1000;
        return abbreviated.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' K';
    }

    return num.toLocaleString('en-IN', { maximumFractionDigits: 2 });
};

/**
 * Formats a number in the Indian numeral formatting system (e.g., 23,432, 34,55,35,345)
 * @param {number|string} number - The number to format
 * @returns {string} - Formatted string
 */
export const formatIndianNumber = (number) => {
    if (number === null || number === undefined || number === '') return '0';

    const num = Number(number);
    if (isNaN(num)) return '0';

    return num.toLocaleString('en-IN');
};

export default formatIndianAmount;
